import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotificationssettingssimplifiinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M20 17H4m0 0a2 2 0 0 0 2-2v-5a6 6 0 0 1 6-6v0a6 6 0 0 1 6 6v5a2 2 0 0 0 2 2v0M19 3.5l1-.5m1 4h1M5 3.5 4 3M3 7H2m8.42 13h3.16"
	})
});
export default SvgNotificationssettingssimplifiinline;
